import { num } from "@/lib/format";

const n2 = (v) => num(Math.round((v || 0) * 100) / 100);

const Status = ({ r }) => {
  if (r.fused) return r.to_fuse ? <span className="font-semibold text-sky-400">Da adesivare {n2(r.to_fuse)} m</span> : <span className="text-emerald-400">Già adesivato</span>;
  if (!r.missing_now) return <span className="text-emerald-400">Disponibile</span>;
  if (!r.to_order) return <span className="text-amber-400">Basta con quello in arrivo</span>;
  return <span className="font-semibold text-rose-400">Da ordinare {n2(r.to_order)} {r.unit}</span>;
};

const Table = ({ title, rows, label, testid }) => (
  <div>
    <h4 className="mb-2 font-display text-sm font-semibold">{title}</h4>
    <div className="overflow-x-auto rounded-md border border-border">
      <table className="w-full text-sm" data-testid={testid}>
        <thead><tr className="border-b border-border text-xs text-muted-foreground">
          <th className="p-2 text-left font-medium">Materiale</th><th className="p-2 text-right font-medium">Serve</th><th className="p-2 text-right font-medium">In magazzino</th>
          <th className="p-2 text-right font-medium">In arrivo</th><th className="p-2 text-right font-medium">Stato</th>
        </tr></thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={i} className="border-b border-border/50 last:border-0" data-testid={`${testid}-row-${i}`}>
              <td className="p-2">{label(r)}</td><td className="p-2 text-right font-semibold">{n2(r.needed)} {r.unit}{!r.fused && r.to_fuse > 0 && <span className="block text-[10px] font-normal text-sky-400">di cui {n2(r.to_fuse)} da adesivare</span>}</td>
              <td className="p-2 text-right">{n2(r.stock)}</td><td className="p-2 text-right">{n2(r.arriving)}</td><td className="p-2 text-right text-xs"><Status r={r} /></td>
            </tr>
          ))}
          {!rows.length && <tr><td colSpan={5} className="p-3 text-xs text-muted-foreground">Nessun consumo indicato.</td></tr>}
        </tbody>
      </table>
    </div>
  </div>
);

export const MaterialsCheck = ({ res }) => (
  <div className="space-y-4">
    <Table title="Tessuti (per tipo e colore)" rows={res?.fabrics || []} label={(r) => `${r.fabric_type} · ${r.color || "senza colore"}${r.fused ? " (adesivato)" : ""}`} testid="check-fabrics" />
    <Table title="Accessori" rows={res?.accessories || []} label={(r) => r.name} testid="check-accessories" />
  </div>
);
